// Aviso fijo cuando el cobro se rechazó porque la venta cambió: no se cobra hasta recargarla.
import { useState } from 'react';
import { RotateCw } from 'lucide-react';
import { Button } from '@/kit';
import { WizardWarningNotice } from './WizardWarningNotice';

export function ChargeReloadNotice({
    message,
    onReload,
}: {
    message: string | undefined;
    onReload: () => Promise<unknown>;
}) {
    const [reloading, setReloading] = useState(false);
    if (!message) return null;
    return (
        <WizardWarningNotice
            action={
                <Button
                    size="sm"
                    variant="secondary"
                    isLoading={reloading}
                    leftIcon={<RotateCw className="size-3.5" aria-hidden />}
                    onClick={() => {
                        setReloading(true);
                        void onReload().finally(() => {
                            setReloading(false);
                        });
                    }}
                >
                    Volver a cargar la venta
                </Button>
            }
        >
            {message}
        </WizardWarningNotice>
    );
}
